export default __webpack_public_path__ + "static/NotoSerif-Bold-0aacbc832fb391fc6a045a72f9c5decb.ttf";